module.exports = __webpack_public_path__ + "img/dk.be60e04c.svg";